import {
    PostPollRateContent,
    SectionContainer,
    SliderContainer,
} from "../PostPollRate.styles";
import { BasePollType } from "../PostPollFactory";
import { usePollIsOpenState } from "../../usePollIsOpenState";
import {
    calculateAverage,
    getUserRating,
    usePollsState,
} from "../../usePollsState";
import { AfterRatingSlider } from "./AfterRatingSlider";
import { BeforeRatingSlider } from "./BeforeRatingSlider";
import { TextMarkup } from "@shared/Components/TextMarkup/TextMarkup";

export const MIN_RATING = 0;
export const MAX_RATING = 10;

export function PostPollRateSection({
    pollClosedAt,
    pollOptionHandler,
    pollOptions: initialPollOptions,
    postId,
    content,
}: BasePollType & { content?: string }) {
    const { open } = usePollIsOpenState(pollClosedAt);
    const {
        handlePollOptionClick,
        pollOptions,
        hasParticipated,
        userOptionId,
    } = usePollsState(initialPollOptions, pollOptionHandler, postId);

    return (
        <SectionContainer>
            {content && (
                <PostPollRateContent>
                    <TextMarkup
                        sx={{
                            color: "var(--community-color-snow-white)",
                            fontSize: "16px",
                            fontWeight: 700,
                        }}
                        textToMarkup={content}
                    />
                </PostPollRateContent>
            )}
            <SliderContainer onClick={(e) => e.stopPropagation()}>
                {hasParticipated ? (
                    <AfterRatingSlider
                        averageRating={calculateAverage(pollOptions)}
                        userRating={getUserRating(pollOptions, userOptionId)}
                    />
                ) : (
                    <BeforeRatingSlider
                        pollOptions={pollOptions}
                        handlePollOptionClick={handlePollOptionClick}
                        open={open}
                    />
                )}
            </SliderContainer>
        </SectionContainer>
    );
}
